import ResourceLinkDTO from '../resourceLinkDTO';
import { AudienceLineDTO } from './audienceLineDTO';
import { Audience_TranslationDTO } from './audience_TranslationDTO';

export class AudienceDTO {
  audienceId: number;

  auditTrailId: number;

  trans: Audience_TranslationDTO[];

  lines?: AudienceLineDTO[];

  links: ResourceLinkDTO[];

  constructor() {
    this.audienceId = 0;
    this.auditTrailId = 0;
    this.trans = [];
    this.links = [];
  }
}
